<!-- UNIVAPLAT-2774: license history modal (per-row reason edit added in the UNIVAPLAT-2757 review pass 1) -->
<div class="modal-dialog modal-dialog-centered admin-modal">
    <div class="modal-content">
        <div class="modal-header">
            <h1 class="modal-title fs-5" data-testid="license-history-title">
                <i class="bi bi-clock-history me-1"></i>
                License history
            </h1>
        </div>
        <div class="modal-body">
            <p class="mb-3" *ngIf="userName">
                User: <strong data-testid="license-history-user-name">{{ userName }}</strong>
            </p>

            <!-- error state: backend message already surfaced via toastr; inline fallback here -->
            <div class="alert alert-danger mb-0" *ngIf="error" data-testid="license-history-error">
                The license history could not be loaded.
            </div>

            <!-- empty state -->
            <div class="alert alert-info mb-0" *ngIf="!loading && !error && entries.length === 0"
                 data-testid="license-history-empty">
                No license history.
            </div>

            <!-- success state: populated table, newest-first as returned by the API -->
            <div class="table-responsive" *ngIf="!loading && !error && entries.length > 0">
                <table class="table table-sm align-middle mb-0" data-testid="license-history-table">
                    <thead>
                        <tr>
                            <th>License</th>
                            <th>Status</th>
                            <th>Deactivation reason</th>
                            <th>Deactivated at</th>
                            <th>Created at</th>
                            <th><span class="visually-hidden">Actions</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entry of entries" data-testid="license-history-row">
                            <td data-testid="license-history-name">{{ entry.license.name }}</td>
                            <td>
                                <!-- expiredAt === null ⇒ the ACTIVE license period -->
                                <span class="badge"
                                      [class.text-bg-success]="entry.expiredAt === null"
                                      [class.text-bg-danger]="entry.expiredAt !== null"
                                      data-testid="license-history-status-badge">
                                    {{ entry.expiredAt === null ? 'Active' : 'Deactivated' }}
                                </span>
                            </td>
                            <td data-testid="license-history-reason">{{ entry.deactivationReason || '-' }}</td>
                            <td data-testid="license-history-expired-at">
                                {{ entry.expiredAt ? (entry.expiredAt | date:'dd/MM/yyyy HH:mm') : '-' }}
                            </td>
                            <td data-testid="license-history-created-at">{{ entry.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
                            <td class="text-end">
                                <!-- deactivated periods only: edit THIS period's reason (explicit licenseId) -->
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                        *ngIf="entry.expiredAt !== null"
                                        (click)="openEditReason(entry)"
                                        data-testid="license-history-edit-reason">
                                    <i class="bi bi-pencil-square me-1"></i>Edit
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="modal-footer">
            <!-- close(mutated): true if any reason edit happened, so the dashboard refreshes -->
            <button type="button" class="btn btn-outline-dark" (click)="modal.close(mutated)"
                    data-testid="license-history-close">Close</button>
        </div>
    </div>
</div>
<!-- loading state -->
<spinner *ngIf="loading"></spinner>
